import {gettext, interpolate} from 'topmeteo/utils/i18n';

const className = 'start-date';

const Label = gettext('Start date: %(date)s');

const getLabel = ({label}) => interpolate(Label, {date: label});

const isAvailable = ({startDate, expirationDate}) => Boolean(startDate) && Boolean(expirationDate) === false;

const getProps = ({startDate}) => ({
    label: getLabel(startDate),
});

export default {className, isAvailable, getProps};
